<form [formGroup]="form" class='ot-remarks-container'>
  <file360-required-label *ngIf="showNewRemarks()" [alignRight]="true"></file360-required-label>
  <div>
    <!-- 
      No placeholder used here due IE11 bug where input event is fired when placeholder fields get focus.
      See FILE-6748
    -->
    <file360-multi-line-text-field *ngIf="showNewRemarks()" label="New remarks" elementId='newremark'
      formControlName="newremark" [maxRows]="getMaxRows()" [minRows]="getMinRows()">
    </file360-multi-line-text-field>
  </div>
  <div>
    <file360-multi-line-text-field *ngIf="showOldRemarks()" label="Remarks" elementId='oldremarks'
      formControlName="oldremarks" [readOnly]="true" [maxHeight]="9"></file360-multi-line-text-field>
  </div>
</form>